import React, { createContext, useContext, useState, useEffect } from "react";
import { api, setRates } from "@/lib/api";

const CurrencyContext = createContext(null);
const STORAGE_KEY = "dabkazari_currency";

export function CurrencyProvider({ children }) {
  const [currency, setCurrencyState] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) || "INR"; } catch { return "INR"; }
  });
  const [ratesLoaded, setRatesLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/currency/rates");
        setRates(data);
      } catch {}
      finally { setRatesLoaded(true); }
    })();
  }, []);

  const setCurrency = (c) => {
    setCurrencyState(c);
    try { localStorage.setItem(STORAGE_KEY, c); } catch {}
  };

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, ratesLoaded }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyContext);
